import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { UzurvDirectivesModule, UzurvPipesModule } from '@uzurv/core';
import { GenericSearchSelectModule } from '../../generic-search-select';
import { EditOrganizationDialogComponent } from './edit-organization-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatChipsModule,
    MatIconModule,
    MatAutocompleteModule,
    GenericSearchSelectModule,
    UzurvPipesModule,
    UzurvDirectivesModule
  ],
  declarations: [EditOrganizationDialogComponent],
  exports: [EditOrganizationDialogComponent]
})
export class EditOrganizationDialogModule {}
